import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../common/header";
import NavigationBar from "../common/navbar";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function AddPage() {
  const { id } = useParams();

  const navigate = useNavigate();
  let [loading, setLoading] = useState(true);
  let [page, setPage] = useState({ name: "", description: "", pageType: "" });
  let [pageErrors, setPageErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (name) => (event) => {
    const { name, value } = event.target;
    setPage({ ...page, [name]: value });
  };

  const navigateToPages = () => {
    navigate("/project/" + localStorage.getItem("project_id") + "/pages");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setPageErrors(validate(page));
    setIsSubmit(true);

  
  };

  useEffect(() => {
    if (Object.keys(pageErrors).length === 0 && isSubmit) {
      if (isSubmit) {
       
        onSubmitData()
      }
    }
  }, [pageErrors]);


  const onSubmitData = async () => {
   
    let result = await fetch(`${process.env.REACT_APP_API_URL}/page`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization:
            "Bearer " +
            JSON.parse(localStorage.getItem("user_info")).accessToken,
        },
        body:JSON.stringify({
          name: page.name,
          description: page.description,
          pageType: page.pageType,
          projectId: localStorage.getItem("project_id"),
          createdBy: JSON.parse(localStorage.getItem("user_info")).id,
        }),
      }
    );
    
    if (result.status==200) {   
      navigate("/project/" + localStorage.getItem("project_id") + "/pages")
    } 
    else if(result.status==400){
      alert("Bad request")
      }
    else{
      localStorage.clear("user_info");
      navigate("/");
    }
 
};


  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = " * Name is Required";
    }
    if (!values.description) {
      errors.description = " * Description is Required";
    }

    return errors;
  };

  const pagetype = [
    { name: "Form", id: "form" },
    { name: "List", id: "list" },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <NavigationBar />
        <div className="col-md-9">
          <Header />
          <h2>Create Page</h2>
          <hr />

          <div className="row">
            <div className="col-md-9">
              <nav>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/organizations">Organizations</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    <Link
                      to={
                        "/projects/" + localStorage.getItem("organization_id")
                      }
                    >
                      Projects
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link
                      to={
                        "/project/" +
                        localStorage.getItem("project_id") +
                        "/pages"
                      }
                    >
                      Pages
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Create New Page</li>
                </ol>
              </nav>
            </div>
          </div>
          <hr />

          <form role="form" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={page.name}
                    onChange={handleChange("name")}
                    onBlur={handleChange("name")}
                  />
                </div>
                <p style={{ color: "red" }}>{pageErrors.name}</p>

                <div className="form-group">
                  <label>Page Type</label>
                  <select
                    className="form-control form-select"
                    id="pageType"
                    name="pageType"
                    value={page.pageType}
                    onChange={handleChange("pageType")}
                  >
                    {/* <option value={pageType.id}>Form</option>
                  <option value={pageType.id}>List</option> */}
                    {pagetype.map((page) => {
                      return (
                        <option name={page.id} value={page.id}>
                          {page.name}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    id="description"
                    aria-rowspan={3}
                    name="description"
                    value={page.description}
                    onChange={handleChange("description")}
                    onBlur={handleChange("description")}
                  ></textarea>
                </div>
                <p style={{ color: "red" }}>{pageErrors.description}</p>
              </div>
            </div>

            <div className="row" style={{ marginBottom: "2rem" }}></div>

            <div className="row">
              <div className="col-md-3">
                <button
                  type="submit"
                  style={{
                    cursor: "pointer",
                    marginRight: "5px",
                    padding: "5px",
                    borderRadius: "4px",
                  }}
                >
                  Submit
                </button>
                <button
                  type="submit"
                  style={{
                    cursor: "pointer",
                    marginRight: "5px",
                    padding: "5px",
                    borderRadius: "4px",
                  }}
                  onClick={navigateToPages}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddPage;
